<template>

  <div class="annotation-axiome-container">
    <v-icon small color="secondary" @click="dialog = true" class="ml-5">mdi-at</v-icon>

    <v-dialog class="annotation-axiome-contenu" v-model="dialog" max-width="50%" scrollable>
      <v-card class="pb-12 px-5 pt-5 overflow-y-auto" max-height="80vh">
        <v-card-title>
          <span class="font-weight-bold text-h4">{{ translatedTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <span class="font-weight-bold font-italic text-h5 ml-12">{{ translatedAbout }}</span>
        <span class="font-weight-bold font-italic text-h5 ml-12 mb-5" v-html="aProposDe"></span>
        <AttributeBlankNode :blankNodes="axiomAnnotations" :separatorDisplay="true" :inAnnotationAxiom="true"
          parentKey="axiomAnnotations" parentNode="axiomAnnotations" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "AxiomAnnotation",
  props: {
    aProposDe: {
      type: String,
      default: ''
    },
    axiomAnnotations: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      dialog: false,
      selectedLanguage: "fr"
    };
  },

  computed: {
    translatedTitle() {
      return this.selectedLanguage === "fr"
        ? "Informations complémentaires"
        : "Additional Information";
    },
    translatedAbout() {
      return this.selectedLanguage === "fr" ? "À propos de:" : "About:";
    }
  },
  watch: {
    "$route.query.lang": {
      handler(newLang) {
        this.selectedLanguage = newLang || "fr";
      },
      immediate: true
    }
  },
};
</script>
